import { DataTableRequest } from 'components/data-table/types'
import api from 'services/technical-visit/technical-visit'

export const handleGetParts = async (request: DataTableRequest) => {
  let res = await api.searchPart(request)

  return res?.data ?? []
}
